const DETAIL_PREFIX = "/images/";

export function routeToPath(route) {
  if (!route || route.name === "gallery") return "/";
  if (route.name === "generate") return "/generate";
  if (route.name === "upload") return "/upload";
  if (route.name === "mypage") {
    const tab = normalizeMypageTab(route.tab);
    return tab && tab !== "created" ? `/mypage?tab=${encodeURIComponent(tab)}` : "/mypage";
  }
  if (route.name === "settings") return "/settings";
  if (route.name === "detail") {
    const id = route.item?.id || route.itemId;
    return id ? DETAIL_PREFIX + encodeURIComponent(id) : "/";
  }
  return "/";
}

export function parsePath(pathname) {
  const path = normalizePath(pathname);
  if (path === "/" || path === "/index.html") return { name: "gallery", itemId: null };
  if (path === "/generate") return { name: "generate", itemId: null };
  if (path === "/upload") return { name: "upload", itemId: null };
  if (path === "/mypage") return { name: "mypage", itemId: null, tab: parseMypageTab() };
  if (path === "/settings") return { name: "settings", itemId: null };
  if (path.startsWith(DETAIL_PREFIX)) {
    return { name: "detail", itemId: decodePathPart(path.slice(DETAIL_PREFIX.length)) };
  }
  return { name: "gallery", itemId: null };
}

function parseMypageTab() {
  if (typeof window === "undefined") return "created";
  try {
    return normalizeMypageTab(new URLSearchParams(window.location.search).get("tab"));
  } catch (e) {
    return "created";
  }
}

function normalizeMypageTab(tab) {
  return ["created", "saved", "liked"].includes(tab) ? tab : "created";
}

export function findRouteItem(items, itemId) {
  if (!itemId || !Array.isArray(items)) return null;
  const exact = items.find((item) => item.id === itemId);
  if (exact) return exact;
  const baseId = itemId.split("__")[0];
  return items.find((item) => item.id === baseId) || null;
}

function normalizePath(pathname) {
  if (!pathname) return "/";
  const path = pathname.split("?")[0].split("#")[0] || "/";
  return path.length > 1 && path.endsWith("/") ? path.slice(0, -1) : path;
}

function decodePathPart(value) {
  try {
    return decodeURIComponent(value);
  } catch (e) {
    return value;
  }
}

if (typeof window !== "undefined") {
  Object.assign(window, { routeToPath, parsePath, findRouteItem });
}
